const doc = [({"da":({"js":({"admin":({"sheet_layouts":({"show":({"show_sheet_layout_name":"Vis arkopsætning: %{name}", "add_new_box":"Tilføj ny boks"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;